import React, { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableSortLabel,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  IconButton,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";

import TableCustomPagination from "./TableCustomPagination";

import { useStylesTable } from "./styles/styles";
import { parse } from "date-fns";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const TableCustom = ({
  columns,
  rows,
  action = false,
  currentPage,
  onCurrentPage,
  actionDisabled,
  count,
  onPageSize,
  pageSize,
  rowsPerPageOptions,
  selectRow = false,
  activePages = true,
  basicPagination = false,
  onClickDetails,
  onClickRead,
  actionButton,
  actionLoading = false,
  readButton = false,
  actionIdButton,
  setSelectRow = {},
  tableClassName,
  sortable = false,
  error = false,
  expandedId = null,
  handleExpandedRow,
  onSort,
  secondaryActionComponent = null,
  renderExpandedRow = () => {},
}) => {
  const classes = useStylesTable();
  const [page, setPage] = useState(currentPage || 0);
  const [rowsPerPage, setRowsPerPage] = useState(pageSize || 25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    onCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    onPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const createSortHandler = (property) => (event) => {
    onSort(event, property);
  };

  const handleClickDetails = (row) => {
    onClickDetails(row);

    const formatExpirationDate = parse(row?.expirationDate, "dd/MM/yyyy 'às' HH:mm'h'", new Date());
    const newRow = {
      ...row,
      expirationDate: formatExpirationDate
    }
    selectRow && setSelectRow(newRow);
  }

  return (
    <Paper className={classes.root}>
      <TableContainer className={`${classes.container} ${tableClassName}`}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns?.filter(c => typeof c.visible === 'undefined' || c.visible === true).map((column) => (
                <TableCell
                  className={classes.head}
                  key={column.id}
                  align={column.align ?? "inherit"}
                  style={{
                    minWidth: column.minWidth,
                    maxWidth: column.maxWidth,
                  }}
                  sortDirection={column.orderBy ?? false}
                >
                  {sortable && column.orderable !== false ? (
                    <TableSortLabel
                      active={column.orderBy ? true : false}
                      direction={column.orderBy ?? "asc"}
                      onClick={createSortHandler(column.id)}
                    >
                      {column.label}
                    </TableSortLabel>
                  ) : (
                    <>{column.label}</>
                  )}
                </TableCell>
              ))}
              {action ? (
                <TableCell className={classes.head} style={{ minWidth: 170 }} />
              ) : null}
              {secondaryActionComponent && (
                <TableCell className={classes.head} style={{ minWidth: 170 }} />
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row) => {
              return (
                <>
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.filter(c => typeof c.visible === 'undefined' || c.visible === true).map((column) => {
                      return (
                        <CellRender
                          key={column.id}
                          row={row}
                          column={column}
                          align={column.align}
                        />
                      );
                    })}

                    {readButton ? (
                      <TableCell align="center">
                        <Button
                          size="small"
                          color="primary"
                          variant="contained"
                          disabled={
                            row.disabledAction ||
                            (row.id === actionIdButton && actionLoading)
                          }
                          onClick={() => onClickRead(row)}
                        >
                          {readButton}
                        </Button>
                      </TableCell>
                    ) : null}

                    {action ? (
                      <TableCell align="center">
                        <Button
                          size="small"
                          color="primary"
                          variant="contained"
                          className={classes.buttonAction}
                          disabled={actionDisabled ? actionDisabled(row) : false}
                          onClick={() => handleClickDetails(row)}
                          style={{
                            backgroundColor: error && !actionDisabled(row) && '#EC5350',
                          }}
                        >
                          {row.id === actionIdButton && actionLoading
                            ? "Carregando..."
                            : actionButton}
                        </Button>
                      </TableCell>
                    ) : null}
                    {secondaryActionComponent && (
                      <TableCell align="center">
                        {secondaryActionComponent(row)}
                      </TableCell>
                    )}
                    {handleExpandedRow && <TableCell>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                      <div style={{marginRight: '20px'}}>
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={() => handleExpandedRow(row)}
                        >
                        {expandedId === row?.installments ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                      </div>
                    </div>
                    </TableCell>}
                  </TableRow>
                  {handleExpandedRow && expandedId === row?.installments &&
                    renderExpandedRow(row)
                  }
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {activePages ? (
        !basicPagination ? (
          <TablePagination
            className={classes.footer}
            rowsPerPageOptions={rowsPerPageOptions || []}
            labelRowsPerPage="Itens por página:"
            component="section"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            ActionsComponent={TableCustomPagination}
          />
        ) : (
          <div className={classes.footer_basic}>
            <Pagination
              shape="rounded"
              color="primary"
              page={page}
              count={count}
              onChange={handleChangePage}
            />
          </div>
        )
      ) : null}
    </Paper>
  );
};

const CellRender = ({ column, row, align }) => {
  if (column.Cell) {
    return <TableCell align={align ?? "inherit"}>{column.Cell(row)}</TableCell>;
  }

  return (
    <TableCell align={align ?? "inherit"}>
      {column?.format ? column.format(row[column.id], row) : row[column.id]}
    </TableCell>
  );
};

export default TableCustom;
